var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.65,
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.001 12.2764C2.001 6.75373 6.47811 2.27649 12.0008 2.27649C17.5234 2.27649 22.0009 6.75373 22.0009 12.2764C22.0009 17.7989 17.5234 22.2765 12.0008 22.2765C6.47811 22.2765 2.001 17.7989 2.001 12.2764ZM18.53 9.85728L12.0009 5.78593L5.47183 9.85728H18.53ZM17.4285 17.5409C18.0815 17.5409 18.6114 17.0117 18.6114 16.3587V10.1163C18.6114 10.0471 18.6043 9.98011 18.5928 9.91413L12.3547 13.804C12.1349 13.9413 11.8654 13.94 11.6478 13.804L5.40967 9.91413C5.3982 9.98011 5.39114 10.0473 5.39114 10.1163V16.3587C5.39114 17.0117 5.9203 17.5409 6.57333 17.5409H17.4285Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2.27649)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7ebb5843b4fc55c127952a5b8dbaddc0.svg";
export { ForwardRef as ReactComponent };